import { j as e } from "./atoms-v218.js";
import { Tag as o, TagContent as r } from "./atoms-v2741.js";
import { SkeletonRow as s } from "./atoms-v2778.js";
const d = ({ ariaLabel: t, className: a, colorTheme: i = "light" }) => /* @__PURE__ */ e.jsx(
  o,
  {
    $colorTheme: i,
    $isDisabled: !1,
    $size: "medium",
    $variant: "gray",
    "aria-hidden": "true",
    "aria-label": t,
    className: a,
    "data-testid": "tag-skeleton",
    children: /* @__PURE__ */ e.jsx(r, { className: "tag-content", children: /* @__PURE__ */ e.jsx(s, { width: "56px" }) })
  }
);
export {
  d as TagSkeleton
};
